import Webcam from 'react-webcam'
import styled from 'styled-components'


export const WebcamWrapper = styled.div`
  position: relative;
`

export const ImagePreview = styled.img`
  max-width: 100%;
  border-radius: 4px;
  border: 1px solid #ffffff3b;
  margin: 5px 0;
`

export const CustomWebcam = styled(Webcam)`
  border-radius: 4px;
  border-width: 1px;
  border-style: solid;
  border-color: ${({error}) => error ? 'red' : 'transparent'}
`

export const Frame = styled.img`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  box-sizing: border-box;
  width: 100%;
  padding: 10px
`
